/**
 * Palette for generated avatars — pair with `getColorForText` from
 * `src/lib/utils.ts` so the same name always lands on the same colour.
 *
 * Deliberately kept off the semantic brand tokens (`--brand-primary`,
 * `--brand-error`, …) so a hashed avatar can never read as a status.
 * Tokens are defined in `src/index.css`.
 */
export const AVATAR_COLORS = [
  'var(--brand-avatar-1)',
  'var(--brand-avatar-2)',
  'var(--brand-avatar-3)',
  'var(--brand-avatar-4)',
  'var(--brand-avatar-5)',
  'var(--brand-avatar-6)',
  'var(--brand-avatar-7)',
  'var(--brand-avatar-8)',
  'var(--brand-avatar-9)',
  'var(--brand-avatar-10)',
  'var(--brand-avatar-11)',
];
